module.exports = __webpack_public_path__ + "img/logo2.74aa1cbf.svg";